module.exports = __webpack_public_path__ + "static/media/wakanim.f67a2984.jpg";